<template>
    <BreadCrumb PageTitle="Liste des articles" />
    <ListeArticle/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import ListeArticle from "../../components/Article/ListeArticle.vue";

    export default defineComponent({
      name: "ListeArticlePage",
      components: {
        BreadCrumb,
        ListeArticle,
      },
    });
  </script>